<template>
  <div>
    <div
      v-if="
        !showPharmacyProfile &&
          !showDiagnosticsProfile &&
          !showBloodBankProfile &&
          !showAmbulanceProfile
      "
    >
      <v-row>
        <v-col cols="12" md="3">
          <label for>Search by name</label>
          <div class="search-div position-relative">
            <input
              class="form-control"
              placeholder="Name"
              v-model="search"
              @input="getCenterList()"
            />
            <div
              v-if="search !== ''"
              class="search-svg position-absolute"
              @click="clearSearch()"
            >
              <crossSVG />
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="position-relative">
            <label for>Per page</label>
            <select
              name
              id
              class="form-control"
              @change="changePage()"
              v-model="recordPerPage"
            >
              <option
                v-for="(option, i) in perPageOptions"
                :key="i"
                :value="option.value"
              >
                {{ option.perPage }}
              </option>
            </select>
            <span class="drop-icon">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-menu-down theme--light position-absolute"
              ></i>
            </span>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="position-relative">
            <label for>Filter by status</label>
            <select
              name
              id
              class="form-control"
              @change="getCenterList()"
              v-model="status"
            >
              <option
                v-for="(option, i) in statusOptions"
                :key="i"
                :value="option.value"
              >
                {{ option.name }}
              </option>
            </select>
            <span class="drop-icon">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-menu-down theme--light position-absolute"
              ></i>
            </span>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div>
            <v-btn
              @click="downloadCsv()"
              class="btn btn-primary export-center-list"
              :disabled="exportLoading"
              >{{ exportLoading ? "Exporting..." : "Export" }}</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <loader v-if="showLoader"></loader>
      <v-row>
        <v-col cols="12" class="mt-2">
          <div class="table-div overflow-auto">
            <table class="table userlistTable table-width small-table-width">
              <thead>
                <tr class="table-success">
                  <th scope="col">Name</th>
                  <th scope="col">City</th>
                  <th scope="col">Status</th>
                  <th scope="col">Requested on</th>
                  <th scope="col" class="small-min-width-120">Verified by</th>
                  <!-- <th></th> -->
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody v-if="!isEmpty">
                <tr v-for="(center, i) in centerList" :key="i">
                  <td>
                    <div>{{ center.center_id.general.name }}</div>
                  </td>
                  <td>
                    <div>
                      {{
                        center.center_id.general.address.city
                          ? `${center.center_id.general.address.city} ${center.center_id.general.address.country}`
                          : "&#8213;"
                      }}
                    </div>
                  </td>
                  <td>
                    <span v-if="center.current_document_status == 'PENDING'">
                      <span class="badge badge-warning">Pending</span>
                      <InfoIconSVG
                        v-if="checkRequestWasRejected(center.histories)"
                        v-c-tooltip.hover.click="
                          'This request was previously rejected. View log to see more details.'
                        "
                        class="info-icon"
                      />
                    </span>
                    <span
                      class="badge badge-success"
                      v-else-if="center.current_document_status == 'APPROVED'"
                      >Approved</span
                    >
                    <span
                      class="badge badge-danger"
                      v-else-if="
                        center.current_document_status == 'NOT_UPLOADED'
                      "
                      >Not Uploaded</span
                    >
                    <span class="badge badge-danger" v-else>Rejected</span>
                  </td>
                  <td>
                    <div>
                      {{ dayJS(center.createdAt).format(formats.date_format) }}
                    </div>
                  </td>
                  <td>
                    <div>
                      <span
                        v-if="
                          center.current_document_status === 'PENDING' ||
                            center.current_document_status === 'NOT_UPLOADED'
                        "
                        >N/A</span
                      >
                      <span
                        v-else-if="
                          center.current_document_status === 'APPROVED'
                        "
                      >
                        {{
                          `${
                            center.approved_details.approved_by_admin
                              ? center.approved_details.approved_by_admin
                                  .first_name
                              : ""
                          } ${
                            center.approved_details.approved_by_admin
                              ? center.approved_details.approved_by_admin
                                  .last_name
                              : ""
                          }`
                        }}
                        <br />
                        <small class="text-muted">
                          {{
                            dayJS(center.approved_details.approved_on).format(
                              formats.date_format
                            )
                          }}
                        </small>
                      </span>
                      <span
                        v-else-if="center.current_document_status === 'REJECT'"
                      >
                        {{
                          center.rejected_details.rejected_by_admin
                            ? `${center.rejected_details.rejected_by_admin.first_name} ${center.rejected_details.rejected_by_admin.last_name}`
                            : ""
                        }}
                        <br />
                        <small class="text-muted">
                          {{
                            dayJS(center.rejected_details.rejected_on).format(
                              formats.date_format
                            )
                          }}
                        </small>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div
                      class="
                        d-flex
                        justify-content-center
                        small-table-padding
                        align-center
                      "
                    >
                      <div
                        v-if="center.current_document_status !== 'NOT_UPLOADED'"
                        class="my-3 mr-2"
                      >
                        <CButton
                          class="text-uppercase"
                          block
                          variant="outline"
                          color="success"
                          v-if="
                            permissions.includes(
                              'CAN_VIEW_HISTORY_CENTER_APPROVAL'
                            )
                          "
                          @click="openCenterLogModal(center)"
                          >View Log</CButton
                        >
                      </div>
                      <div class="my-3">
                        <div
                          v-if="center.current_document_status === 'PENDING'"
                        >
                          <CButton
                            class="text-uppercase"
                            block
                            variant="outline"
                            color="success"
                            v-if="
                              permissions.includes(
                                'CAN_APPROVE_REJECT_CENTER_APPROVAL'
                              )
                            "
                            @click="verifyCenter('Verify', center)"
                            >Verify</CButton
                          >
                        </div>
                        <div
                          v-if="center.current_document_status === 'APPROVED'"
                        >
                          <CButton
                            block
                            variant="outline"
                            color="success"
                            @click="verifyCenter('View', center)"
                            v-if="
                              permissions.includes(
                                'CAN_VIEW_DOCUMENT_CENTER_APPROVAL'
                              )
                            "
                            >View</CButton
                          >
                        </div>

                        <div
                          v-if="
                            center.current_document_status === 'NOT_UPLOADED'
                          "
                        >
                          <CButton
                            block
                            variant="outline"
                            color="danger"
                            @click="verifyCenter('Reject', center)"
                            v-if="
                              permissions.includes(
                                'CAN_APPROVE_REJECT_CENTER_APPROVAL'
                              )
                            "
                            >Reject</CButton
                          >
                        </div>
                        <div v-if="center.current_document_status === 'REJECT'">
                          <CButton
                            block
                            variant="outline"
                            color="danger"
                            v-if="
                              permissions.includes(
                                'CAN_VIEW_DOCUMENT_CENTER_APPROVAL'
                              )
                            "
                            @click="verifyCenter('Reason', center)"
                            >Reason</CButton
                          >
                        </div>
                      </div>
                      <!-- <div class="my-3 mb-xl-0 contact-div d-flex">
                      <div class="inner-div">
                        <messageSVG />
                      </div>
                      <div class="inner-div">
                        <phoneSVG />
                      </div>
                      <div class="inner-div">
                        <emailSVG />
                      </div>
                      </div>-->
                      <div class="action-div small-table-padding">
                        <div>
                          <CDropdown
                            color="link"
                            size="lg"
                            :caret="false"
                            class="dropdowndocbox"
                          >
                            <template #toggler-content>
                              <verticalDotsSVG />
                            </template>
                            <CDropdownItem @click="getViewDetails(center)"
                              >View Details</CDropdownItem
                            >
                            <CDropdownItem>Call</CDropdownItem>
                            <CDropdownItem>Chat</CDropdownItem>
                            <CDropdownItem>Email</CDropdownItem>
                          </CDropdown>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr></tr>
              </tbody>
              <tbody v-if="isEmpty">
                <tr>
                  <td colspan="6">
                    <h2 class="text-center">No Data Found</h2>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>

      <pagination
        v-if="!isEmpty"
        class="mob-t-center pagination-block"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
      />

      <center-log-modal
        v-if="showCenterLogModal"
        :showCenterLogModal="showCenterLogModal"
        :centerData="centerData"
        @close="closeModal()"
        @openViewDetails="openViewDetails"
      ></center-log-modal>

      <center-approval-modal
        v-if="showCenterApprovalModal"
        :showCenterApprovalModal="showCenterApprovalModal"
        :statusType="statusType"
        :centerData="centerData"
        @close="closeModal()"
        @refreshList="getCenterList()"
      ></center-approval-modal>

      <image-preview
        @close="closeImageModal"
        v-if="openImageModal"
        :openImageModal="openImageModal"
        :source="fileUrl"
        :fileArcheType="fileArcheType"
      ></image-preview>
    </div>

    <pharmacyProfileSummaryDetails
      v-if="showPharmacyProfile"
      @close="closeProfile()"
      :centerId="userId"
    ></pharmacyProfileSummaryDetails>
    <diagnosticsLabProfileSummaryDetails
      v-if="showDiagnosticsProfile"
      @close="closeProfile()"
      :centerId="userId"
    ></diagnosticsLabProfileSummaryDetails>
    <bloodBankProfileSummaryDetails
      v-if="showBloodBankProfile"
      @close="closeProfile()"
      :centerId="userId"
    ></bloodBankProfileSummaryDetails>
    <ambulanceProfileSummaryDetails
      v-if="showAmbulanceProfile"
      @close="closeProfile()"
      :centerId="userId"
    ></ambulanceProfileSummaryDetails>
  </div>
</template>

<script>
import config from "@/config.js";
import formats from "@/formats";
import { pickSvg } from "@/views/SVG";
import InfoIconSVG from "@/views/SVG/InfoIconSVG";
import { mapGetters } from "vuex";
const imagePreview = () => import("@/components/modals/imagePreview.vue");
const pagination = () => import("@/views/common/Pagination");
const loader = () => import("@/components/loader.vue");
const centerApprovalModal = () =>
  import("@/components/ApprovalCenters/centerApprovalModal.vue");
const centerLogModal = () =>
  import("@/components/ApprovalCenters/centerLogModal.vue");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
export default {
  props: ["centerType"],
  components: {
    ...pickSvg("messageSVG", "phoneSVG", "emailSVG"),
    "center-log-modal": centerLogModal,
    "center-approval-modal": centerApprovalModal,
    "image-preview": imagePreview,
    pagination,
    InfoIconSVG,
    loader,
    pharmacyProfileSummaryDetails: () =>
      import("@/views/dashboardNew/userListing/pharmacyProfileSummaryDetails"),
    diagnosticsLabProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/diagnosticsLabProfileSummaryDetails"
      ),
    bloodBankProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/bloodBankProfileSummaryDetails.vue"
      ),
    ambulanceProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/ambulanceProfileSummaryDetails.vue"
      ),
  },
  data() {
    return {
      exportLoading: false,
      showPharmacyProfile: false,
      showDiagnosticsProfile: false,
      showBloodBankProfile: false,
      showAmbulanceProfile: false,
      dayJS,
      formats,
      recordPerPage: 10,
      currentPage: 1,
      search: "",
      status: "ALL",
      centerList: [],
      total: "",
      perPageOptions: [
        { perPage: 10, value: 10 },
        { perPage: 20, value: 20 },
        { perPage: 30, value: 30 },
        { perPage: 50, value: 50 },
        { perPage: 100, value: 100 },
      ],
      statusOptions: [
        { name: "All", value: "ALL" },
        { name: "Pending", value: "PENDING" },
        { name: "Approved", value: "APPROVED" },
        { name: "Rejected", value: "REJECT" },
        { name: "Not Uploaded", value: "NOT_UPLOADED" },
      ],
      showLoader: false,
      isEmpty: false,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
      centerData: {},
      showCenterApprovalModal: false,
      statusType: "",
      showCenterLogModal: false,
    };
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  mounted() {
    this.getCenterList();
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    closeProfile() {
      this.showPharmacyProfile = false;
      this.showDiagnosticsProfile = false;
      this.showBloodBankProfile = false;
      this.showAmbulanceProfile = false;
    },
    getViewDetails(centerData) {
      const centerId = centerData.center_id._id;
      switch (this.centerType) {
        case "pharmacy":
          this.showPharmacyProfile = true;
          this.userId = centerId;
          break;

        case "diagnostics-lab":
          this.showDiagnosticsProfile = true;
          this.userId = centerId;
          break;
        case "bloodbank":
          this.showBloodBankProfile = true;
          this.userId = centerId;
          break;
        case "ambulance":
          this.showAmbulanceProfile = true;
          this.userId = centerId;
          break;

        default:
          this.showPharmacyProfile = false;
          this.showDiagnosticsProfile = false;
          this.showBloodBankProfile = false;
          this.showAmbulanceProfile = false;
          this.userId = "";
      }
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getCenterList();
    },
    openViewDetails(history) {
      this.openImageModal = true;
      this.closeModal();
      this.fileUrl = history.registration_proof_image_url;
      this.fileArcheType = "Certificate";
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    verifyCenter(type, centerData) {
      this.centerData = centerData;
      this.showCenterApprovalModal = true;
      this.statusType = type;
    },
    openCenterLogModal(centerData) {
      this.centerData = centerData;
      this.showCenterLogModal = true;
    },
    closeModal() {
      this.showCenterLogModal = false;
      this.showCenterApprovalModal = false;
    },
    getCenterList() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        search_text: this.search,
        status: this.status,
        center_type: this.centerType,
      };
      let url = `${config.BASE_URL}api/v2/admin/centers`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.centerList = response.body.data.list;
            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.centerList = [];
            this.isEmpty = true;
          }
        }
      });
    },
    downloadCsv() {
      this.exportLoading = true;
      let params = {
        search_text: this.search,
        status: this.status,
        center_type: this.centerType,
      };
      let url = `${config.BASE_URL}api/v2/admin/centers/export`;
      this.$http
        .get(url, { params })
        .then((response) => {
          if (response.body.status) {
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(
              new Blob(["\ufeff", response.body.data])
            );
            downloadLink.download = "center-approval-list.csv";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    checkRequestWasRejected(histories) {
      let truth = false;
      histories.forEach((history) => {
        if (history.current_document_status == "REJECT") {
          truth = true;
        }
      });
      return truth;
    },
  },
};
</script>
≈

<style>
.export-center-list {
  margin-top: 30px;
}
</style>
